import { render, staticRenderFns } from "./ActionBar.vue?vue&type=template&id=0310ca70&scoped=true&"
import script from "./ActionBar.vue?vue&type=script&lang=js&"
export * from "./ActionBar.vue?vue&type=script&lang=js&"
import style0 from "./ActionBar.vue?vue&type=style&index=0&id=0310ca70&scoped=true&lang=css&"
import style1 from "./ActionBar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0310ca70",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSelect,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0310ca70')) {
      api.createRecord('0310ca70', component.options)
    } else {
      api.reload('0310ca70', component.options)
    }
    module.hot.accept("./ActionBar.vue?vue&type=template&id=0310ca70&scoped=true&", function () {
      api.rerender('0310ca70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/ActionBar.vue"
export default component.exports